var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7253 0C14.4711 0 16 1.602 16 4.347V13.644C16 16.434 14.4711 18 11.7253 18H4.27556C1.57333 18 0 16.434 0 13.644V4.347C0 1.602 1.57333 0 4.27556 0H11.7253ZM4.51556 12.366C4.24889 12.339 3.99111 12.465 3.84889 12.699C3.70667 12.924 3.70667 13.221 3.84889 13.455C3.99111 13.68 4.24889 13.815 4.51556 13.779H11.4844C11.8391 13.743 12.1067 13.4361 12.1067 13.077C12.1067 12.708 11.8391 12.402 11.4844 12.366H4.51556ZM11.4844 8.2611H4.51556C4.13244 8.2611 3.82222 8.577 3.82222 8.964C3.82222 9.351 4.13244 9.666 4.51556 9.666H11.4844C11.8667 9.666 12.1778 9.351 12.1778 8.964C12.1778 8.577 11.8667 8.2611 11.4844 8.2611ZM7.17244 4.185H4.51556V4.194C4.13244 4.194 3.82222 4.509 3.82222 4.896C3.82222 5.283 4.13244 5.598 4.51556 5.598H7.17244C7.55556 5.598 7.86667 5.283 7.86667 4.8861C7.86667 4.5 7.55556 4.185 7.17244 4.185Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.57cc50e27076bf575a762c483ec9176e.svg";
export { ForwardRef as ReactComponent };